/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import _ from "underscore";
import React from "react";

import NavLink from "./navLink";
import NavGroup from "./navGroup";
import { onAdminPage, onSuperAdminPage } from "../../utils";

const barChart = require("../svg/barChart.svg");
const officeBuilding = require("../svg/officeBuilding.svg");
const userGroup = require("../svg/userGroup.svg");
const gift = require("../svg/gift.svg");
const book = require("../svg/book.svg");
const puzzle = require("../svg/puzzle.svg");
const lifeRaft = require("../svg/lifeRaft.svg");
const toggleOn = require("../svg/toggleOn.svg");
const toggleOff = require("../svg/toggleOff.svg");

interface SuperAdminNavSectionProps {
  expandedGroup: string;
  handleGroupClick: any;
  handleInitialLoad: any;
  isDemoing: boolean;
  isSuperAdmin: boolean;
  location: string;
  navigationShrunk: boolean;
  permissions: any;
  quickSpoofCompanies: any;
}

export default class SuperAdminNavSection extends React.Component<
  SuperAdminNavSectionProps,
  any
> {
  static defaultProps = {
    expandedGroup: null,
  };

  render() {
    // NOTE: isSuperAdmin means someone is allowed to be a super admin
    //       permissions.includes("superAdmin") means super admin is toggled on
    const showSuperAdminMenu =
      this.props.isSuperAdmin &&
      (onSuperAdminPage(this.props.location) ||
        onAdminPage(this.props.location));

    const isSuperAdminToggledOn = this.props.permissions.includes("superAdmin");

    if (showSuperAdminMenu) {
      return (
        <div className="link-grouping super-admin-links">
          <h4>Superadmin</h4>

          <div className="super-admin-toggle">
            <p className="text">Turn on/off permissions</p>
            <a href="/users/toggle_super_admin_controls" data-method="PATCH">
              <img
                className="toggle-img"
                src={isSuperAdminToggledOn ? toggleOn : toggleOff}
              />
            </a>
          </div>

          {isSuperAdminToggledOn && (
            <div className="super-admin-nav-groups">
              <NavGroup
                navigationShrunk={this.props.navigationShrunk}
                location={this.props.location}
                onInitialLoad={this.props.handleInitialLoad}
                groupId="metrics"
                expandedId={this.props.expandedGroup}
                onClick={this.props.handleGroupClick}
                label="Metrics"
                iconSvg={<img src={barChart} />}
              >
                <NavLink
                  location={this.props.location}
                  label="Rewards"
                  url="/super_admin/metrics/rewards"
                />
                <NavLink
                  location={this.props.location}
                  label="Rewards by country"
                  url="/super_admin/metrics/country_rewards"
                />
                <NavLink
                  location={this.props.location}
                  label="Bonuses"
                  url="/super_admin/metrics/bonuses"
                />
                <NavLink
                  location={this.props.location}
                  label="Sign ups"
                  url="/super_admin/metrics/sign_ups"
                />
                <NavLink
                  location={this.props.location}
                  label="Seats"
                  url="/super_admin/metrics/seats"
                />
                <NavLink
                  location={this.props.location}
                  label="Integrations"
                  url="/super_admin/metrics/integrations"
                />
                <NavLink
                  location={this.props.location}
                  label="Participation"
                  url="/super_admin/metrics/participation"
                />
                <NavLink
                  location={this.props.location}
                  label="Participation v2"
                  url="/super_admin/metrics/dynamic_participation"
                />
                <NavLink
                  location={this.props.location}
                  label="Bonus reports"
                  url="/super_admin/metrics/bonus_reports"
                />
              </NavGroup>
              <NavGroup
                navigationShrunk={this.props.navigationShrunk}
                location={this.props.location}
                onInitialLoad={this.props.handleInitialLoad}
                groupId="companies"
                expandedId={this.props.expandedGroup}
                onClick={this.props.handleGroupClick}
                label="Companies"
                iconSvg={<img src={officeBuilding} />}
              >
                <NavLink
                  location={this.props.location}
                  label="Manage"
                  url="/super_admin/companies"
                />
                <NavLink
                  location={this.props.location}
                  label="Sign ups"
                  url="/super_admin/sign_up_activity"
                />
                <NavLink
                  location={this.props.location}
                  label="Invite report"
                  url="/super_admin/companies/invite_report"
                />
                <NavLink
                  location={this.props.location}
                  label="Integrations"
                  url="/super_admin/integrations_dashboards"
                />
              </NavGroup>
              <NavGroup
                navigationShrunk={this.props.navigationShrunk}
                location={this.props.location}
                onInitialLoad={this.props.handleInitialLoad}
                groupId="super-admin-users"
                expandedId={this.props.expandedGroup}
                onClick={this.props.handleGroupClick}
                label="Users"
                iconSvg={<img src={userGroup} />}
              >
                <NavLink
                  location={this.props.location}
                  label="Manage"
                  url="/super_admin/spoof/new"
                />
                <NavLink
                  location={this.props.location}
                  label="Alias"
                  url="/super_admin/alias_users/new"
                />
              </NavGroup>
              <NavGroup
                navigationShrunk={this.props.navigationShrunk}
                location={this.props.location}
                onInitialLoad={this.props.handleInitialLoad}
                groupId="super-admin-rewards"
                expandedId={this.props.expandedGroup}
                onClick={this.props.handleGroupClick}
                label="Rewards"
                iconSvg={<img src={gift} />}
              >
                <NavLink
                  location={this.props.location}
                  label="Manage"
                  url="/super_admin/rewards"
                />
                <NavLink
                  location={this.props.location}
                  label="Health"
                  url="/super_admin/rewards/health_check"
                />
                <NavLink
                  location={this.props.location}
                  label="Tangocard orders"
                  url="/super_admin/tangocard_orders"
                />
                <NavLink
                  location={this.props.location}
                  label="Manually fulfilled"
                  url="/super_admin/manually_fulfilled_rewards"
                />
                <NavLink
                  location={this.props.location}
                  label="Buffered denominations"
                  url="/super_admin/buffered_denominations"
                />
              </NavGroup>
              <NavGroup
                navigationShrunk={this.props.navigationShrunk}
                location={this.props.location}
                onInitialLoad={this.props.handleInitialLoad}
                groupId="catalog"
                expandedId={this.props.expandedGroup}
                onClick={this.props.handleGroupClick}
                label="Catalog"
                iconSvg={<img src={book} />}
              >
                <NavLink
                  label="Manage"
                  location={this.props.location}
                  url="/super_admin/items"
                />
                <NavLink
                  location={this.props.location}
                  label="Providers"
                  url="/super_admin/catalog/accounts"
                />
                <NavLink
                  location={this.props.location}
                  label="Public brands"
                  url="/super_admin/catalog/public_brands"
                />
                <NavLink
                  location={this.props.location}
                  label="Out of Stock"
                  url="/super_admin/catalog/out_of_stock"
                />
                <NavLink
                  location={this.props.location}
                  label="Lint"
                  url="/super_admin/catalog/lint"
                />
                <NavLink
                  location={this.props.location}
                  label="Unimplemented brands"
                  url="/super_admin/catalog/unimplemented_brands"
                />
                <NavLink
                  location={this.props.location}
                  label="Promoted brands"
                  url="/super_admin/catalog/promoted"
                />
              </NavGroup>
              <NavGroup
                navigationShrunk={this.props.navigationShrunk}
                location={this.props.location}
                onInitialLoad={this.props.handleInitialLoad}
                groupId="developer"
                expandedId={this.props.expandedGroup}
                onClick={this.props.handleGroupClick}
                label="Developer"
                iconSvg={<img src={puzzle} />}
              >
                <NavLink
                  location={this.props.location}
                  label="Marmon SFTP Sync"
                  url="/super_admin/user_management_integrations/marmon_sync/"
                />
                <NavLink
                  location={this.props.location}
                  label="Internals"
                  url="/super_admin/control_panel"
                />
                <NavLink
                  location={this.props.location}
                  label="Email"
                  url="/super_admin/mailer/index"
                />
                <NavLink
                  location={this.props.location}
                  label="Reward certificates"
                  url="/super_admin/test/reward_certificates"
                />
                <NavLink
                  location={this.props.location}
                  label="Logo analysis"
                  url="/super_admin/test/logo_analysis"
                />
                <NavLink
                  location={this.props.location}
                  label="Avatars"
                  url="/super_admin/test/avatar"
                />
                <NavLink
                  location={this.props.location}
                  label="Integration errors"
                  url="/super_admin/integration_errors"
                />
                <NavLink
                  location={this.props.location}
                  label="Language feedback"
                  url="/super_admin/language_feedbacks"
                />
                <NavLink
                  location={this.props.location}
                  label="Beta feedback"
                  url="/super_admin/beta_feedbacks"
                />
                <NavLink
                  location={this.props.location}
                  label="Analytics feedback"
                  url="/super_admin/analytics_chart_feedbacks"
                />
                <NavLink
                  location={this.props.location}
                  label="Donation payouts"
                  url="/super_admin/donation_payouts"
                />
                <NavLink
                  location={this.props.location}
                  label="Quality bot reports"
                  url="/super_admin/bonus_quality_bot_reports"
                />
                <NavLink
                  location={this.props.location}
                  label="Events"
                  url="/super_admin/events"
                />
                <NavLink
                  location={this.props.location}
                  label="Design system"
                  url="https://design.bonus.ly"
                />
              </NavGroup>
              {this.props.permissions.includes("techOps") && (
                <NavGroup
                  navigationShrunk={this.props.navigationShrunk}
                  location={this.props.location}
                  onInitialLoad={this.props.handleInitialLoad}
                  groupId="super-admin-quality-ops"
                  expandedId={this.props.expandedGroup}
                  onClick={this.props.handleGroupClick}
                  label="Quality ops"
                  iconSvg={<img src={lifeRaft} />}
                >
                  <NavLink
                    location={this.props.location}
                    label="Everything"
                    url="/tech_ops"
                  />
                  <NavLink
                    location={this.props.location}
                    label="Company specific"
                    url="/tech_ops/company"
                  />
                  <NavLink
                    location={this.props.location}
                    label="User specific"
                    url="/tech_ops/user"
                  />
                </NavGroup>
              )}
            </div>
          )}
        </div>
      );
    }

    return null;
  }

  renderSpoofLinks = () => {
    return _.map(this.props.quickSpoofCompanies, (company, i) => {
      return (
        <NavLink
          label={company.name}
          url={company.path}
          key={i}
          dataMethod="post"
        />
      );
    });
  };
}
